import React, { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { useContext, useEffect, useRef} from 'react';
import 'dayjs/locale/pt';
import { axiosBackend } from '../../../axios/Axios.js';
import { getToken } from "../../../services/auth";
import { useSnackbar } from 'notistack'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './GerarRelatorios.module.scss';

export default function GerarRelatorios({handleReload, isOpen, onClose, uuid }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    startDate: dayjs(),
    endDate: dayjs(),
    detailed: false
  });

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      "start": '' + formData.startDate.unix(),
      "end": '' + formData.endDate.unix(),
      "detailed": formData.detailed,
      "uuid": uuid
    }

    await axiosBackend.post('/relatorios', payload, config).then(res => {
      onClose();
      enqueueSnackbar('O relatório está sendo gerado!\nAtualize a página para atualizar o status.\nTempo estimado: 2 min.', { 
        variant: 'success',
        style: { whiteSpace: 'pre-line' }
      });
      handleReload();
    }).catch((err) => {
      enqueueSnackbar('Falha ao solicitar relatório.', { 
        variant: 'error'
      });
    });
    setLoading(false);
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
      <div className={styles.modalContainer}>
        <div className={styles.modalContentMc}>
        <h1>Escolha um período</h1>
        <div className={styles.row}>
          <div className={styles.field}>
          <label className={styles.field_title}>Data inicial do levantamento</label>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              value={formData.startDate}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, startDate: newValue })}
              />
            </LocalizationProvider>

          </div>
          <div className={styles.middle}>até</div>
          <div className={styles.field}>
          <label className={styles.field_title}>Data final do levantamento</label>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              value={formData.endDate}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, endDate: newValue })}
              />
          </LocalizationProvider>

          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.field_detailed}>
            <label className={styles.field_title}>Tipo de relatório</label>
            <div className={styles.simp_det} onChange={(e) => setFormData({ ...formData, detailed: e.target.value === 'Detalhado' })}>
              <label>
                <input checked={!formData.detailed} type="radio" name="type" value="Simples" onChange={(e) => setFormData({ ...formData, detailed: e.target.value === 'Detalhado' })}/>
                Simples
              </label>
              <label>
                <input checked={formData.detailed} type="radio" name="type" value="Detalhado" onChange={(e) => setFormData({ ...formData, detailed: e.target.value === 'Detalhado' })}/>
                Detalhado
              </label>
            </div>
          </div>

          <button
            className={styles.cancelar}
            onClick={() => {
              console.log(formData);
              onClose();
            }}
          >
            Cancelar
          </button>
          <button
            className={styles.download}
            onClick={() => {
              handleSubmit();
            }}
          >
            Gerar relatório
          </button>
        </div>
      </div>
      </div>
    </div>
  );
}